import { motion } from 'framer-motion'
import styled from 'styled-components'
import { COLORS } from 'consts/colors'
import { DROPDOWN_Z_INDEX } from 'consts/zIndex'

export const DropdownOverlayWrapper = styled(motion.div)<{
  width: number
  left: number
  top: number
  height: string
}>`
  position: fixed;
  width: ${props => `${props.width}px`};
  left: ${props => `${props.left}px`};
  top: ${props => `${props.top}px`};
  height: ${props => props.height};
  background: ${COLORS.white};
  border-radius: 4px;
  border: 1px solid ${COLORS.borderColor};
  box-shadow: 0px 4px 16px 0px rgba(56, 102, 255, 0.15);
  z-index: ${DROPDOWN_Z_INDEX};
  overflow: hidden;
  display: flex;
  flex-direction: column;
`
